// eslint-disable-next-line import/no-unresolved
import 'swiper/swiper-bundle.min.css';
import '../scss/base.scss'; // styles
import main from '../../../../assets/js/_main';
import logCitationClickDPL from '../../../../assets/js/log-citation-click-dpl';

// import { loadScript } from '@s1/core/utilities';

/**
 * We are going to remove this for now and perhaps split test it later. Way too big of a package.
 */
// const loadAdBlockSquared = () => {
//   // Ad Block Squared (APUB-601)
//   let s1sid = window?.s1?.markupModifier?.s1sid ? window.s1.markupModifier.s1sid
//      : window.s1?.blockInjector?.s1sid;
//   s1sid = s1sid || '';
//   loadScript('https://s.flocdn.com/adblockersquared/adblockersquared.umd.min.js', () => {
//     const Adblockersquared = window.adblockersquared?.Adblockersquared || '';
//     if (Adblockersquared) {
//       Adblockersquared({
//         disableModal: true,
//         s1sid,
//         dpl: {
//           business: 'publishing',
//         },
//       });
//     }
//   });
// };

window.addEventListener('DOMContentLoaded', () => {
  main();

  logCitationClickDPL();
  window.s1.alpine.start();

  /*
  * We are going to remove this for now and perhaps split test it later. Way too big of a package.
  *
  if (window.s1?.CmpWrapper) {
    window.s1.CmpWrapper.enqueue(loadAdBlockSquared, 1);
  }
  */
});
